import React, { Suspense } from 'react'

import { Redirect, Route } from 'react-router-dom'

import { Loader } from '@driftt/tide-core'

import { Page } from 'types/pages'

const ProtectedRoute: React.FC<Page> = ({
  Component,
  key,
  path,
  hasAccess,
  exact = false,
}) => {
  return (
    <Route
      key={key}
      path={path}
      exact={exact}
      render={(props) => {
        if (!hasAccess) {
          return <Redirect to="/" />
        }
        return (
          <Suspense fallback={() => <Loader />}>
            {Component && <Component {...props} />}
          </Suspense>
        )
      }}
    />
  )
}

export default ProtectedRoute
